<template>
  <div class="page-wrapper mt-3" style="width: 100%">
    <PageTitle title="Ai промпты" />
    <TogglerOfWrapper>
      <template v-slot:name>Подсказка</template>
      <template v-slot:content>
        <p class="mb-3">На данной странице отображаются Ai промпты.</p>
        <v-label>Выставьте фильтры</v-label>
        <ol class="pl-5">
          <li><strong>учебный год</strong></li>
        </ol>
      </template>
    </TogglerOfWrapper>

    <div style="display: flex; justify-content: center; flex-wrap: wrap">
      <div class="page-wrapper mt-3 w-100">
        <AppButton @click="$router.back" class="bordered-item ma-2">Назад</AppButton>
        <AppButton @click="createPrompt" class="bordered-item ma-2">Добавить промпт</AppButton>
        <!-- СЕТКА КАРТОЧЕК ИИ-ПРОМПТОВ  -->
           <v-row class="ma-1 mt-3" v-if="prompts.length > 0">
             <!-- Применяем знания сетки: cols="12" (мобилки), sm="6" (планшеты), md="4" (ноутбуки/мониторы) -->
             <v-col
               cols="12"
               sm="6"
               md="4"
               v-for="prompt in prompts"
               :key="prompt.id"
               class="pa-2"
             >
               <v-card
                 variant="outlined"
                 class="bg-white rounded-xl shadow-soft h-100 d-flex flex-column justify-space-between  transition-card"
               >
                 <!-- Верхняя контентная часть карточки -->
                 <div>
                   <v-card-item class="bg-indigo-lighten-5 py-3">
                     <div class="d-flex align-center justify-space-between">
                       <div class="d-flex align-center  mr-2">
                         <v-icon color="indigo-darken-4" class="mr-2">mdi-robot-outline</v-icon>
                         <strong class="text-subtitle-1 text-indigo-darken-4">
                           {{ prompt.promptName }}
                         </strong>
                       </div>
                       <v-chip size="x-small" color="indigo" variant="flat" class="font-weight-bold flex-shrink-0">
                         ID: {{ prompt.id }}
                       </v-chip>
                     </div>
                   </v-card-item>

                   <v-card-text class="pa-4">
                     <!-- Краткое превью тела промпта (обрезается через CSS на 3 строки) -->
                     <p class="text-body-2 text-grey-darken-3 prompt-preview-text mb-3">
                       {{ prompt.promptBody }}
                     </p>

                     <v-divider class="my-2"></v-divider>

                     <!-- Метаданные: Счетчик критериев -->
                     <div class="d-flex justify-space-between align-center my-2">
                       <span class="text-caption text-grey-darken-1 font-weight-medium">
                         <v-icon size="x-small" start color="grey">mdi-format-list-bulleted-type</v-icon>
                         Показателей матрицы:
                       </span>
                       <v-chip size="x-small" color="secondary" variant="tonal" class="font-weight-bold">
                         {{ prompt.promptCriteriaList ? prompt.promptCriteriaList.length : 0 }} критериев
                       </v-chip>
                     </div>

                     <!-- Метаданные: Создатель и дата -->
                     <div class="mt-2 pt-2 border-top-light-cards">
                       <div class="text-caption text-grey d-flex align-center">
                         <v-icon size="x-small" start>mdi-account-circle-outline</v-icon>
                         <span class="text-truncate">Создатель: {{ prompt.creator || 'Система' }}</span>
                       </div>
                       <div class="text-caption text-grey d-flex align-center mt-1">
                         <v-icon size="x-small" start>mdi-calendar-clock</v-icon>
                         <span>Изменен: {{ formatDateTime(prompt.createDateTime) }}</span>
                       </div>
                     </div>
                   </v-card-text>
                 </div>

                 <v-card-actions class="px-4 pb-4 pt-0">
                             <v-btn
                               v-if="haveAdmin || userId === prompt.creatorId"
                               icon="mdi-delete-outline"
                               size="small"
                               variant="outlined"
                               color="error"
                               class="rounded-md"
                               title="Удалить промпт"
                               @click="deletePrompt(prompt.id)"
                             ></v-btn>

                             <v-spacer></v-spacer>

                             <v-btn
                               icon="mdi-content-copy"
                               size="small"
                               variant="outlined"
                               color="info"
                               class="rounded-md mr-1"
                               title="Создать дубликат этого промпта"
                               @click="duplicatePrompt(prompt.id)"
                             ></v-btn>

                             <v-btn
                               icon="mdi-pencil-outline"
                               size="small"
                               variant="outlined"
                               color="deep-orange-darken-1"
                               class="rounded-md mr-1"
                               @click="openPrompt(prompt)"
                             >

                             </v-btn>
                           </v-card-actions>
               </v-card>
             </v-col>
           </v-row>

           <!-- Заглушка, если база промптов пуста -->
           <v-alert v-else-if="!showLoader" type="info" variant="tonal" class="ma-2 rounded-xl">
             Библиотека промптов пуста. Нажмите кнопку «Добавить промпт», чтобы создать первый ИИ-скрипт проверки.
           </v-alert>
      </div>

      <!-- Диалог просмотра чистого текста тела промпта -->
      <v-dialog v-model="showDialog" persistent>
        <v-card>
          <v-card-text>
            <div style="white-space: pre-line">{{ showBody }}</div>
          </v-card-text>

          <template v-slot:actions>
            <v-btn @click="closeData()" color="red-lighten-2" text="закрыть" variant="outlined" block></v-btn>
          </template>
        </v-card>
      </v-dialog>

     <!-- МОДАЛКА: Профессиональный полноразмерный редактор ИИ-промптов -->
         <v-dialog
           v-model="promptDialog"
           max-width="1200px"
           width="95%"
           persistent
           scrollable
         >
           <v-card class="rounded-xl overflow-hidden d-flex flex-column" style="height: 90vh;">
             <!-- Шапка окна с кнопками сохранения и удаления -->
             <v-card-title class="bg-deep-orange-darken-1 px-6 py-4 text-white d-flex align-center justify-space-between flex-wrap gap-2">
               <div class="d-flex align-center">
                 <v-icon start class="mr-2">mdi-xml</v-icon>
                 <span class="text-h6 font-weight-bold">{{ id ? 'Настройки ИИ-скрипта проверки' : 'Регистрация нового промпта' }}</span>
               </div>

               <div class="d-flex align-center gap-2">
                 <!-- Кнопка «Удалить»: полупрозрачная, не перетягивает на себя внимание -->
                 <v-btn
                   v-if="id && (haveAdmin || userId === promptCreatorId)"
                   prepend-icon="mdi-delete-outline"
                   color="deep-orange-darken-4"
                   variant="outlined"
                   density="comfortable"
                   class="font-weight-bold px-4 rounded-md bg-white-trans text-white"
                   @click="deletePrompt(id)"
                 >
                   Удалить
                 </v-btn>

                 <!-- Кнопка «Сохранить»: яркая, плоская, главное целевое действие -->
                 <v-btn
                   color="deep-orange-darken-4"
                   variant="flat"
                   density="comfortable"
                   class="font-weight-black px-5 rounded-md "
                   :disabled="saveIsDisable"
                   @click="savePrompt"
                 >
                   Сохранить
                 </v-btn>

                 <v-btn
                   icon="mdi-close"
                   variant="text"
                   color="white"
                   density="compact"
                   @click="closePromptDialog"
                 ></v-btn>
               </div>
             </v-card-title>

             <!-- Основная скролл-зона контента (Занимает всю высоту модалки) -->
             <v-card-text class="pa-4 pa-md-6 bg-grey-lighten-4 flex-grow-1 overflow-y-auto">
               <v-row class="ma-0">

                 <!-- Поле ввода названия промпта -->
                 <v-col cols="12" class="pa-1 mb-2">
                   <v-text-field
                     v-model="promptName"
                     :rules="promptNameRules"
                     label="Название промпта*"
                     variant="outlined"
                     bg-color="white"
                     density="comfortable"
                     :counter="250"
                     hide-details="auto"
                   ></v-text-field>
                 </v-col>

                 <!-- КРИТИЧЕСКОЕ ИСПРАВЛЕНИЕ: Поле ввода ТЕЛА промпта с защитой от горизонтального скролла -->
                 <v-col cols="12" class="pa-1 mb-4">
                   <v-textarea
                     v-model="promptBody"
                     :rules="promptBodyRules"
                     label="Системное тело промпта (Инструкция ИИ)*"
                     variant="outlined"
                     bg-color="white"
                     auto-grow
                     rows="10"
                     max-rows="18"
                     class="custom-prompt-textarea"
                     hint="Доступны плейсхолдеры {criteriaList}, {examplesList} и маркер [Данные для анализа]"
                     persistent-hint
                   ></v-textarea>
                 </v-col>

                 <!-- ДИНАМИЧЕСКИЙ БЛОК АТОМАРНЫХ КРИТЕРИЕВ -->
                 <v-col cols="12" class="pa-1">
                   <v-card variant="flat" class="pa-4 bg-white rounded-xl border">
                     <div class="d-flex justify-space-between align-center mb-4 flex-wrap gap-2">
                       <div>
                         <span class="text-subtitle-1 font-weight-bold text-indigo-darken-4 d-block" style="line-height: 1.2;">
                           Матрица критериев атомарной оценки (AI)
                         </span>
                         <span class="text-caption text-grey">Настройте шкалу пересчета и примеры разбора</span>
                       </div>

                       <v-btn
                         prepend-icon="mdi-plus"
                         color="deep-orange-darken-1"
                         variant="outlined"
                         size="small"
                         class="font-weight-bold px-4 rounded-md"
                         @click="addCriterion"
                       >
                         Добавить критерий
                       </v-btn>
                     </div>

                     <v-divider class="mb-4"></v-divider>

                     <!-- Контейнер для SortableJS Dnd -->
                     <div ref="criteriaContainer" class="d-flex flex-column gap-3">
                       <div
                         v-for="(criterion, index) in promptCriteriaList"
                         :key="index"
                         class="pa-4 rounded-xl border bg-grey-lighten-5 d-flex align-start position-relative transition-card"
                       >
                         <!-- Ручка для перетаскивания (Drag Handle) -->
                         <div class="drag-handle mr-3 mt-2 cursor-grab">
                           <v-icon color="grey-darken-1">mdi-drag-vertical</v-icon>
                         </div>

                         <!-- Поля ввода инструкции и примера -->
                         <div class="flex-grow-1">
                           <div class="font-weight-black text-subtitle-2 text-indigo-darken-3 mb-2">
                             Показатель №{{ criterion.criteriaOrder }}
                           </div>

                           <v-textarea
                             v-model="criterion.criteriaBody"
                             label="Текст критерия из матрицы оценивания (Шкала баллов 0-3)*"
                             variant="outlined"
                             bg-color="white"
                             density="compact"
                             rows="3"
                             auto-grow
                             class="mb-3 custom-prompt-textarea"
                             hide-details="auto"
                           ></v-textarea>

                           <v-textarea
                             v-model="criterion.criteriaExample"
                             label="Эталонный пример разбора ИИ для этого критерия (Обоснование и цитаты)"
                             variant="outlined"
                             bg-color="white"
                             density="compact"
                             rows="3"
                             auto-grow
                             class="custom-prompt-textarea"
                             hide-details="auto"
                           ></v-textarea>
                         </div>

                         <!-- Кнопка удаления критерия -->
                         <v-btn
                           icon="mdi-trash-can-outline"
                           variant="text"
                           color="error"
                           size="small"
                           class="ml-2 mt-7"
                           @click="removeCriterion(index)"
                         ></v-btn>
                       </div>
                     </div>

                     <div v-if="promptCriteriaList.length === 0" class="text-center text-caption text-grey py-6 font-italic">
                       Матрица пуста. Добавьте хотя бы один показатель для разбора эссе.
                     </div>
                   </v-card>
                 </v-col>

               </v-row>
             </v-card-text>
           </v-card>
         </v-dialog>
    </div>
  </div>
</template>


<script setup>
import { onMounted, ref, computed, onBeforeUnmount, watch, nextTick } from "vue";
import { formatDateTime } from "@/util/common";
import AppButton from "@/elements/AppButton.vue";

import TogglerOfWrapper from "@/components/elements/TogglerOfWrapper.vue";
import PageTitle from "@/elements/PageTitle.vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/store/auth";
import { customAxios } from "@/service/customAxios";
import { usePopupStore } from "@/store/popup";
import { debounce } from "@/util/common";
import Sortable from 'sortablejs';


// Ссылка на DOM-элемент контейнера, в котором лежат строки критериев
const criteriaContainer = ref(null);
let sortableInstance = null; // Переменная для хранения инстанса сортировки

// Состояние авторизации и всплывающих окон из Pinia
const { userId, haveAdmin } = storeToRefs(useAuthStore());
const { showError } = usePopupStore();

// Предохранитель для блокировки ложных срабатываний автосохранения при открытии модалки
const isInitializing = ref(false);

// Реактивные переменные интерфейса
const snackbar = ref(false);
const snackbarMessage = ref('Сохранено!');
const prompts = ref([]);
const promptName = ref('');
const promptBody = ref('');

// Реактивный массив для хранения критериев текущего открытого промпта
const promptCriteriaList = ref([]);

const promptDialog = ref(false);
const id = ref();
const promptCreatorId = ref();

// Правила валидации Vuetify (Возвращены promptBodyRules для текстовой области промпта)
const promptNameRules = ref([
  (v) => !!v || "Поле обязательно для заполнения!",
  (v) => (v && v.length <= 250) || "Значение не должно превышать 250 символов!",
]);
const promptBodyRules = ref([
  (v) => !!v || "Поле обязательно для заполнения!",
  (v) => (v && v.length <= 25000) || "Значение не должно превышать 25000 символов!",
]);

const showLoader = ref(false);
const showDialog = ref(false);
const showBody = ref('');


const saveIsDisable = computed(() => {
  const nameLen = promptName.value ? promptName.value.toString().trim().length : 0;
  const bodyLen = promptBody.value ? promptBody.value.toString().trim().length : 0;

  let hasEmptyCriteria = false;
  if (promptCriteriaList.value && Array.isArray(promptCriteriaList.value)) {
    hasEmptyCriteria = promptCriteriaList.value.some(c => {
      if (!c) return false;
      const bodyText = c.criteriaBody ? c.criteriaBody.toString().trim() : '';
      return bodyText.length === 0; // Блокируем, если строка инструкции добавлена, но пуста
    });
  }

  return nameLen === 0 || bodyLen === 0 || hasEmptyCriteria;
});


const windowHeight = ref(window.innerHeight);


function updateWindowHeight() {
  windowHeight.value = window.innerHeight;
}

const debouncedSave = debounce(savePrompt, 1000);

/**
 * Вызов глубокого копирования промпта на бэкенде
 */
async function duplicatePrompt(promptId) {
  try {
    const r = await customAxios.post(`/v1/prompts/${promptId}/copy`);
    if (r.status === 200) {

      await getAiPrompts();
      snackbarMessage.value = "Дубликат промпта успешно создан!";
      snackbar.value = true;
    }
  } catch (e) {
    showError(e); // Выведет ошибку, если что-то пошло не так
  }
}

watch(promptBody, (newVal, oldVal) => {
  console.log("promptBody changed");
  if (!isInitializing.value && newVal && newVal.length && newVal !== oldVal) {
    if (id.value && haveAdmin.value || id.value && userId.value === promptCreatorId.value) {
      debouncedSave();
    }
  }
});

watch(promptName, (newVal, oldVal) => {
  console.log("promptName changed");
  if (!isInitializing.value && newVal && newVal.length && newVal !== oldVal) {
    if (id.value && haveAdmin.value || id.value && userId.value === promptCreatorId.value) {
      debouncedSave();
    }
  }
});


watch(promptCriteriaList, () => {
  console.log("promptCriteriaList changed");
  if (!isInitializing.value && id.value && (haveAdmin.value || userId.value === promptCreatorId.value)) {
    debouncedSave();
    }
}, { deep: true });


function initDragAndDrop() {
  if (sortableInstance) {
    sortableInstance.destroy();
  }

  nextTick(() => {
    if (!criteriaContainer.value) return;

    sortableInstance = new Sortable(criteriaContainer.value, {
      animation: 150,
      handle: '.drag-handle',
      ghostClass: 'bg-light-blue-lighten-5',

      onEnd: (evt) => {
        if (evt.oldIndex === evt.newIndex) return;

        // Копируем реактивный массив в обычный локальный список
        const localList = [...promptCriteriaList.value];

        // ИСПРАВЛЕНО: Извлекаем строго нулевой элемент из возвращаемого splice массива,
        // чтобы movedItem был чистым плоским объектом критерия, а не вложенным массивом!
        const movedItem = localList.splice(evt.oldIndex, 1)[0];

        // Вставляем чистый объект в новую позицию
        localList.splice(evt.newIndex, 0, movedItem);

        // Пересчитываем порядковые номера
        localList.forEach((criterion, idx) => {
          if (criterion) {
            criterion.criteriaOrder = idx + 1;
          }
        });

        promptCriteriaList.value = localList;
      }
    });
  });
}

function addCriterion() {
  const nextOrder = promptCriteriaList.value ? promptCriteriaList.value.length + 1 : 1;
  promptCriteriaList.value.push({
    id: null,
    criteriaOrder: nextOrder,
    criteriaBody: '',
    criteriaExample: ''
  });
}

function removeCriterion(index) {
  if (!promptCriteriaList.value) return;

  promptCriteriaList.value.splice(index, 1);
  // Пересчитываем порядковые номера оставшихся критериев
  promptCriteriaList.value.forEach((criterion, idx) => {
    if (criterion) {
      criterion.criteriaOrder = idx + 1;
    }
  });
}


async function openPrompt(prompt) {
  isInitializing.value = true;

  id.value = prompt.id;
  promptCreatorId.value = prompt.creatorId;
  promptName.value = prompt.promptName;
  promptBody.value = prompt.promptBody;

  // Безопасный маппинг критериев и защита от null из старых записей БД
  promptCriteriaList.value = prompt.promptCriteriaList
    ? prompt.promptCriteriaList.map(c => ({
        id: c.id || null,
        criteriaOrder: c.criteriaOrder,
        criteriaBody: c.criteriaBody || '',
        criteriaExample: c.criteriaExample || '' // Фолбек на пустую строку
      }))
    : [];

  promptDialog.value = true;
  initDragAndDrop();

  await nextTick();
  isInitializing.value = false;
}

async function createPrompt() {
  isInitializing.value = true;

  id.value = "";
  promptName.value = "";
  promptBody.value = "";
  promptCreatorId.value = userId.value;
  promptCriteriaList.value = [];

  promptDialog.value = true;
  initDragAndDrop();

  await nextTick();
  isInitializing.value = false;
}

async function closePromptDialog() {
  isInitializing.value = true;

  promptName.value = "";
  promptBody.value = "";
  id.value = "";
  promptCreatorId.value = "";
  promptCriteriaList.value = [];

  promptDialog.value = false;
  await getAiPrompts();

  await nextTick();
  isInitializing.value = false;
}


/**
 * Удаление промпта с каскадной защитой бэкенда
 */

async function deletePrompt(promptId) {
  if (!confirm("Вы уверены, что хотите безвозвратно удалить этот ИИ-промпт?")) return;

  try {
    const r = await customAxios.post(`/v1/prompts/${promptId}/delete`);
    if (r.status === 200) {
      snackbarMessage.value = "Промпт успешно удален";
      snackbar.value = true;
      await getAiPrompts();
      closePromptDialog();
    }
  } catch (e) {
    showError(e);
  }
}


async function savePrompt() {
  const prompt = {
    promptName: promptName.value,
    promptBody: promptBody.value,
    criteriaList: promptCriteriaList.value
  };

  if (id.value) {
    try {
      const r = await customAxios.put("/v1/prompts/" + id.value, prompt);
      if (r.status === 202 || r.status === 200) {
        snackbarMessage.value = "Промпт успешно изменен";
        snackbar.value = true;

        // ИСПРАВЛЕНО: Точечно проставляем сгенерированные БД ID в существующие объекты.
        // Массив promptCriteriaList останется идеально плоским и готовым к Drag and Drop
        if (r.data && r.data.promptCriteriaList) {
          r.data.promptCriteriaList.forEach((incoming, idx) => {
            if (promptCriteriaList.value[idx]) {
              promptCriteriaList.value[idx].id = incoming.id;
            }
          });
        }
      }
    } catch (e) {
      console.log("error: " + e);
      if (e && e.response && e.response.data && e.response.data.message) {
        snackbarMessage.value = e.response.data.message;
      } else {
        snackbarMessage.value = "Ошибка при сохранении промпта!";
      }
      snackbar.value = true;
    }
  } else {
    try {
      const r = await customAxios.post("/v1/prompts", prompt);
      if (r.status === 201) {
        if (r.data && r.data.id) {
          id.value = r.data.id;
        }
        promptCreatorId.value = r.data.creatorId;

        // Синхронизируем ID созданных критериев для ветки POST
        if (r.data && r.data.promptCriteriaList) {
          r.data.promptCriteriaList.forEach((incoming, idx) => {
            if (promptCriteriaList.value[idx]) {
              promptCriteriaList.value[idx].id = incoming.id;
            }
          });
        }

        snackbarMessage.value = "Промпт успешно создан";
        snackbar.value = true;
      }
    } catch (e) {
      console.log("error: " + e);
      if (e && e.response && e.response.data && e.response.data.message) {
        snackbarMessage.value = e.response.data.message;
      } else {
        snackbarMessage.value = "Ошибка при сохранении промпта!";
      }
      snackbar.value = true;
    }
  }
}

async function getAiPrompts() {
  console.log("in update");
  showLoader.value = true;
  try {
    const r = await customAxios.get("/v1/prompts");
    if (r.status === 200) {
      prompts.value = r.data;
    } else {
      prompts.value = [];
    }
    showLoader.value = false;
  } catch (e) {
    console.log("error: " + e);
    if (e && e.response && e.response.data && e.response.data.message) {
      showError(e.response.data.message);
    } else {
      showError(e);
      prompts.value = [];
    }
    showLoader.value = false;
  }
}


onMounted(() => {
  window.addEventListener('resize', updateWindowHeight);
  updateWindowHeight();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowHeight);
  if (sortableInstance) {
    sortableInstance.destroy();
  }
});

onMounted(async () => {
  console.log("Валидация подключена:", promptBodyRules.value);
  await getAiPrompts();
});
</script>
<style scoped>
   /* Элегантные стили для сетки ИИ-промптов */
   .shadow-soft {
     box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.04) !important;
   }
   .rounded-xl {
     border-radius: 14px !important;
   }
   .border-top-light-cards {
     border-top: 1px solid rgba(0, 0, 0, 0.06);
   }
   .rounded-md {
     border-radius: 6px !important;
   }

   /* Умное ограничение текста: показывает строго первые 3 строки промпта, а дальше ставит троеточие */
   .prompt-preview-text {
     display: -webkit-box;
     -webkit-line-clamp: 3;
     -webkit-box-orient: vertical;
     overflow: hidden;
     text-overflow: ellipsis;
     line-height: 1.5;
     height: 4.5em; /* Фиксированная высота для выравнивания сеток */
   }

   /* Анимация плавного выделения карточки при наведении */
   .transition-card {
     transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out !important;
   }
   .transition-card:hover {
     transform: translateY(-4px);
     box-shadow: 0 6px 26px 0 rgba(26, 35, 126, 0.08) !important;
     border-color: rgba(63, 81, 181, 0.4) !important;
   }

   /* Жесткий принудительный перенос слов для предотвращения горизонтального скролла в промптах */
   .custom-prompt-textarea :deep(textarea) {
     white-space: pre-wrap !important;
     word-break: break-word !important; /* Ломает длинные склеенные строки JSON */
     overflow-x: hidden !important;    /* Намертво блокирует горизонтальную прокрутку инпута */
   }

   /* Стили для аккуратной сетки модального окна */
   .gap-2 { gap: 8px !important; }
   .gap-3 { gap: 12px !important; }
   .cursor-grab { cursor: grab; }
   .cursor-grab:active { cursor: grabbing; }

   .bg-white-trans {
     background-color: rgba(255, 255, 255, 0.15) !important;
     border-color: rgba(255, 255, 255, 0.3) !important;
   }
   .bg-white-trans:hover {
     background-color: rgba(255, 255, 255, 0.25) !important;
   }

   /* Легкая анимация фокуса на строке критерия */
   .transition-card {
     transition: border-color 0.2s ease-in-out;
   }
   .transition-card:focus-within {
     border-color: rgb(var(--v-theme-primary)) !important;
     background-color: #fff !important;
   }

</style>